import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component, createRef, render } from "preact";
import { payOnTheDaySchedule } from '../api/Client';
import { PaymentMethodComponent } from "./PaymentMethodComponent";
export class SchedulePayOnTheDayComponent extends Component {
    constructor() {
        super();
        this.paymentMethodComponent = createRef();
        this.state = {
            processing: false
        };
        document.addEventListener('--get-token-finish', () => {
            this.setState({
                processing: true
            });
            const paymentForm = this.paymentMethodComponent.current.getPaymentFormObject();
            payOnTheDaySchedule(this.props.preserveCode, paymentForm).then(result => {
                location.href = result.data.acs
                    ? result.data.acs
                    : `/schedules/payontheday/finish/${this.props.preserveCode}`;
            }).catch(e => {
                this.setState({
                    processing: false
                });
                alert(e.response.data.error);
                throw e;
            });
        });
    }
    render() {
        return (_jsxs(_Fragment, { children: [_jsx(PaymentMethodComponent, { storeId: this.props.storeId, storeType: this.props.storeType, cartType: "SCHEDULE", ref: this.paymentMethodComponent }, void 0),
                _jsx("footer", Object.assign({ class: "mt4" }, { children: _jsx("div", Object.assign({ class: "flex flex__row flex__justify-content-center my2" }, { children: _jsx("button", Object.assign({ type: "button", class: "button button__danger button__md w50", onClick: () => { this.payment(); }, disabled: this.state.processing }, { children: this.state.processing ? '処理中' : '決済' }), void 0) }), void 0) }), void 0)] }, void 0));
    }
    payment() {
        this.paymentMethodComponent.current?.submitHook();
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('#SchedulePayOnTheDayComponent');
    if (root) {
        const storeId = Number(root.getAttribute('data-store-id'));
        const storeType = root.getAttribute('data-store-type');
        const preserveCode = root.getAttribute('data-preserve-code');
        render(_jsx(SchedulePayOnTheDayComponent, { storeId: storeId, storeType: storeType, preserveCode: preserveCode }, void 0), root);
    }
});
